import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { WorkspaceMemberRoleValue } from "#src/config/filter/workspace/value";
import { ButtonV2 } from "#src/commonV2/Button";
import { ArrowUpRight, FilePlus02 } from "@untitled-ui/icons-react";
import { ESolutionKey } from "./enum";

export interface ISolution {
  key: ESolutionKey;
  logo: ReactNode;
  title: string;
  description: string;
  url: string;
  publicUrl?: string;
  isExternal?: boolean;
  enabled: boolean;
  isCreate?: boolean;
  comingSoon?: boolean;
}

interface ISolutionCardProps {
  solutionItem: ISolution;
  role: WorkspaceMemberRoleValue | undefined;
}

export const SolutionCard = ({ solutionItem, role }: ISolutionCardProps) => {
  const { t } = useTranslation("solutions", { keyPrefix: "actions" });

  return (
    <div className="rounded-xl flex flex-col justify-between gap-6 bg-white p-6 shadow-xs border border-gray-v2-200">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-4">
          <div className="w-11 h-11 p-1.5 flex-shrink-0 flex items-center justify-center bg-white rounded-md border border-gray-v2-200">
            {solutionItem.logo}
          </div>
          <span className="text-lg font-semibold text-gray-v2-900">
            {solutionItem.title}
          </span>
        </div>
        <p className="text-md text-gray-v2 line-clamp-3 min-h-[4.5rem]">
          {solutionItem.description}
        </p>
      </div>
      <div className="flex justify-end">
        {solutionItem.comingSoon ? (
          <ButtonV2 size="sm" disabled>
            {t("comingSoon")}
          </ButtonV2>
        ) : role === WorkspaceMemberRoleValue.OWNER ||
          solutionItem.publicUrl === undefined ? (
          <a
            href={solutionItem.url}
            rel="noreferrer"
            target={solutionItem.isExternal ? "_blank" : "_parent"}
          >
            {solutionItem.isCreate ? (
              <ButtonV2 variant="secondary" size="sm">
                <FilePlus02 className="w-5 h-5 min-w-5" />
                <span>{t("createNewProject")}</span>
              </ButtonV2>
            ) : solutionItem.enabled ? (
              <ButtonV2 size="sm">{t("open")}</ButtonV2>
            ) : (
              <ButtonV2 variant="secondary" size="sm">
                {t("startNow")}
                <ArrowUpRight className="w-5 h-5 min-w-5" />
              </ButtonV2>
            )}
          </a>
        ) : (
          <a href={solutionItem.publicUrl} rel="noreferrer" target="_blank">
            {solutionItem.enabled ? (
              <ButtonV2 size="sm">{t("open")}</ButtonV2>
            ) : (
              <ButtonV2 variant="secondary" size="sm">
                {t("startNow")}
                <ArrowUpRight className="w-5 h-5 min-w-5" />
              </ButtonV2>
            )}
          </a>
        )}
      </div>
    </div>
  );
};
